module.exports = __webpack_public_path__ + "static/a3-e6f9d7bd1992ea4a1f4ec0ae79197b0d.png";